import React, { Component } from "react";
import { Table, Button, Input, Switch, Modal, message, Tooltip } from "antd";
import axios from "axios";
import "./Pages.css";
import ParametroNFeCFOPForm from '../components/ParametroNFeCFOPForm';
import moment from "moment-timezone"; // VALIDAR DATAS
import { getUsuario } from "../utils/LoginManager";
import { resolveImageUrl } from '../utils/Storage';
import { getTemPermissao } from "../utils/LoginManager";

const { Column } = Table;
const { Search } = Input;
const ButtonGroup = Button.Group;

export default class extends Component {
  state = {
    listaRegistros: [],
    carregando: false,
    pagina: 1,
    limite: 10,
    total: 0,
    buscaOrdem: { campo: 'pcfop_cfop_dentro_uf', ordem: 'ASC' },
  };

  componentDidMount() {
    const usuario = getUsuario();
    this.setState({ usuario });
    this.getListaRegistros();
  }

  componentDidUpdate(antProps, antState) {
    const { total, pagina, limite } = this.state;
    const ultimaPagina = Math.ceil(total / limite);
    if (pagina > 1 && pagina > ultimaPagina) {
      this.setState({
        pagina: ultimaPagina
      }, this.getListaRegistros)
    }
  }



  getListaRegistros = () => {
    this.setState({ listaRegistros: [], carregando: true });
    const { busca, pagina, limite, buscaOrdem } = this.state;
    axios
      .get('/parametrosNfeCFOP', {
        params: {
          page: pagina,
          limite: limite,
          campoOrdem: buscaOrdem.campo,
          tipoOrdem: buscaOrdem.ordem,
          buscaDescricao: busca,
        }
      })
      .then(response => {
        const { data, total, current_page, per_page } = response.data;
        this.setState({
          listaRegistros: data,
          carregando: false,
          total: total,
          pagina: current_page,
          limite: Number(per_page),
        });
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          carregando: false,
        });
      });
  };




  onSalvarClick = (registro) => {
    this.setState({ salvando: true })

    let request;
    if (registro.pcfop_idf) {
      request = axios.put(`/parametrosNfeCFOP/update/${registro.pcfop_idf}`, registro);
    } else {
      request = axios.post(`/parametrosNfeCFOP/store`, registro)
    }

    request
      .then(response => {
        this.getListaRegistros();
        this.setState({
          formVisivel: false,
          salvando: false,
        })
        message.success('Parâmetros gravados com sucesso');
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          salvando: false
        })
        Modal.error({ title: 'Falha - Atenção!', content: 'Não foi possível salvar. ' + error.response.data, okText: 'OK', })
      })
  }


  onEditarClick = (registro, visualizar) => {
    this.setState({ carregando: true });
    axios.get(`/parametrosNfeCFOP/show/${registro.pcfop_idf}`)
      .then(response => {
        const { data } = response;

        // console.log('onEditarClick', data)

        data.pcfop_municipio = {
          key: data.pcfop_municipio ? String(data.pcfop_municipio) : '0',
          label: data.cmun_descricao ? data.cmun_descricao : '',
          cmun_uf: data.cmun_uf ? String(data.cmun_uf) : '',
          cuf_sigla: data.cuf_sigla ? data.cuf_sigla : '',
        };

        data.pcfop_cfop_dentro_uf = { key: data.pcfop_cfop_dentro_uf ? String(data.pcfop_cfop_dentro_uf) : '' };
        data.pcfop_cfop_fora_uf = { key: data.pcfop_cfop_fora_uf ? String(data.pcfop_cfop_fora_uf) : '' };
        data.pcfop_cfop_estrangeiro = { key: data.pcfop_cfop_estrangeiro ? String(data.pcfop_cfop_estrangeiro) : '' };
        data.pcfop_tipo_mov_nf = { key: data.pcfop_tipo_mov_nf ? String(data.pcfop_tipo_mov_nf) : '' };
        data.pcfop_regime_contribuinte = { key: data.pcfop_regime_contribuinte ? String(data.pcfop_regime_contribuinte) : '' };
        data.pcfop_natureza = { key: data.pcfop_natureza ? String(data.pcfop_natureza) : '' };
        data.pcfop_tipo_produto = { key: data.pcfop_tipo_produto ? String(data.pcfop_tipo_produto) : '' };

        this.setState({
          formVisivel: true,
          registroSelecionado: data,
          visualizar,
          carregando: false,
        })
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          carregando: false,
        })
      })
  };



  onBuscar = (texto) => {
    this.setState({
      busca: texto
    },
      this.getListaRegistros);
  };

  onAdicionarClick = () => {
    this.setState({
      formVisivel: true,
      registroSelecionado: {
        pcfop_idf: 0,
        pcfop_cfop_dentro_uf: { key: '' },
        pcfop_cfop_fora_uf: { key: '' },
        pcfop_cfop_estrangeiro: { key: '' },
        pcfop_tipo_mov_nf: { key: '' },
        pcfop_regime_contribuinte: { key: '' },
        pcfop_natureza: { key: '' },
        pcfop_municipio: {
          key: '0',
          label: '',
          cmun_uf: '0',
          cuf_sigla: '',
        },
        pcfop_tipo_produto: { key: '' },
      }
    })
  };

  onExcluirClick = registro => {
    Modal.confirm({
      title: 'Confirmação de Exclusão',
      content: `Deseja excluir este registro?`,
      okText: 'Sim',
      cancelText: 'Não',
      onOk: () => {
        this.setState({ carregando: true });
        axios.delete(`/parametrosNfeCFOP/delete/${registro.pcfop_idf}`)
          .then(response => {
            const { listaRegistros, total } = this.state;
            const registroIndex = listaRegistros.findIndex(tar => tar.pcfop_idf === registro.pcfop_idf)
            listaRegistros.splice(registroIndex, 1);
            this.setState({
              listaRegistros: listaRegistros.concat([]),
              total: total - 1,
              carregando: false,
            })

          }).catch(error => {
            console.error(error.response);
            this.setState({
              carregando: false,
            })
          })
      }
    })
  };


  onCancelarClick = () => {
    this.setState({
      formVisivel: false
    })
  }



  renderAcoes = (text, registro) => {
    return (
      <ButtonGroup size="small">
        {getTemPermissao('ParametrosNFeCFOPPage', 'editar') ? (
          <Tooltip title="Editar">
            <Button type="primary" size="small" onClick={() => this.onEditarClick(registro, false)} icon="edit" />
          </Tooltip>
        ) : (
          <Tooltip title="Visualizar">
            <Button type="ghost" size="small" onClick={() => this.onEditarClick(registro, true)} icon="eye" />
          </Tooltip>
        )}
        {getTemPermissao('ParametrosNFeCFOPPage', 'excluir') ? (
          <Tooltip title="Excluir">
            <Button type="danger" size="small" onClick={() => this.onExcluirClick(registro)} icon="delete" />
          </Tooltip>
        ) : null}
      </ButtonGroup>
    );
  };


  onTabelaChange = (pagination => {
    this.setState({
      pagina: pagination.current,
      limite: pagination.pageSize,
    },
      this.getListaRegistros)
  })

  onOrdenarListaClick = (column) => {
    const { filtros } = this.state;
    const ordem = this.state.buscaOrdem.campo && this.state.buscaOrdem.campo === column.dataIndex ? (this.state.buscaOrdem.ordem && this.state.buscaOrdem.ordem === 'ASC' ? 'DESC' : 'ASC') : 'ASC';
    this.state['buscaOrdem'] = { campo: column.dataIndex, ordem };
    this.setState({
      filtros,
      pagina: 1,
    }, this.getListaRegistros)
  };

  renderTitulo = (col) => {
    return (
      <Tooltip title="Clique para Ordenar"><div style={{ background: "#ececec", cursor: 'pointer', padding: 2, marginLeft: -5, marginRight: -5 }}>{col}</div></Tooltip>
    );
  };


  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------


  render() {
    const { listaRegistros, carregando, formVisivel, salvando, registroSelecionado,
      total, pagina, limite } = this.state;

    return (
      <div className="contentRoutesContainer">
        <span className="tituloPage">Parâmetros CFOP NFe</span>
        <div className="divider-page1" />

        <div className="pageFiltro">
          <Button
            type="primary"
            onClick={this.onAdicionarClick}
            className="botao-primary"
          >
            Adicionar
          </Button>

          <ParametroNFeCFOPForm
            visivel={formVisivel}
            onSalvarClick={this.onSalvarClick}
            onCancelarClick={this.onCancelarClick}
            carregando={salvando}
            registroSelecionado={registroSelecionado}
          />
        </div>

        <br />

        <Table
          pagination={{
            total: total,
            pageSize: limite,
            current: pagina,
            pageSizeOptions: ['10', '20', '30', '40', '50'],
            showSizeChanger: true,
          }}
          onChange={this.onTabelaChange}
          loading={{
            spinning: carregando,
            tip: 'Carregando. Aguarde...',
            size: "large"
          }}
          dataSource={listaRegistros}
          rowKey={(registro => registro.pcfop_idf)}
        >
          <Column
            key="pcfop_cfop_dentro_uf"
            dataIndex="pcfop_cfop_dentro_uf"
            title={this.renderTitulo("CFOP Dentro UF")}
            onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
            render={this.renderPFJ}
            width={60}
            align="left"
            className="listaCadastro"
          />
          <Column
            key="pcfop_cfop_fora_uf"
            dataIndex="pcfop_cfop_fora_uf"
            title={this.renderTitulo("CFOP Fora UF")}
            onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
            width={60}
            align="left"
            className="listaCadastro"
          />
          <Column
            key="pcfop_cfop_estrangeiro"
            dataIndex="pcfop_cfop_estrangeiro"
            title={this.renderTitulo("CFOP Ex")}
            onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
            width={60}
            align="center"
            className="listaCadastro"
          />
          <Column
            key="pcfop_natureza"
            dataIndex="pcfop_natureza"
            title={this.renderTitulo("Nat Oper")}
            onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
            width={60}
            align="center"
            className="listaCadastro"
          />
          <Column
            key="acoes"
            title={<div style={{ background: "#ececec", padding: 2, marginLeft: -5, marginRight: -5 }}>.</div>}
            render={this.renderAcoes}
            width={70}
            align="center"
            className="listaCadastro"
          />
        </Table>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/ParametrosNFeCFOPPage.js